<template>
    <va-create-layout>
        <AffordabilityExpenseReversalEvent-form
            :title="title"
            :item="item"
        ></AffordabilityExpenseReversalEvent-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
